export enum EAssetColumnKeys {
  AlphaCode = 'alpha_code',
  AssetCode = 'asset_code',
  Issuer = 'asset_issuer',
  Owned = 'owned',
  Status = 'status',
}

export enum EAssetStatus {
  Live = 'live',
}

export enum EAssetAction {
  Disable = 'disable',
  Delete = 'delete',
}
